

type idDefComponent = {
    [key: string]: { length: number, child: idDefComponent | undefined };
}


type idComponent = {
    length : number,
    code : string
}


type questionIdComponent = idComponent & { answer : idComponent};
type bankIdComponent = idComponent & { question : questionIdComponent, tree : idComponent};
type quizIdComponent = idComponent & { bank : bankIdComponent , metric : idComponent};
type messageIdComponent = idComponent & { voting : idComponent};
type chatIdComponent = idComponent & {message : messageIdComponent};
type postElementIdComponent = idComponent & {voting : idComponent};
type postIdComponent = idComponent & {element : postElementIdComponent, voting : idComponent};
type chunkIdComponent = idComponent & {quiz : quizIdComponent, post : postIdComponent, creative : idComponent};
type partyIdComponent = idComponent & {chat : chatIdComponent, main : chunkIdComponent, optional : chunkIdComponent, popularity: idComponent, votable : idComponent};

const _postIdComponent : postIdComponent = {
    length : 6,
    code : 'ps',
    element : {
        length : 2,
        code : 'el',
        voting : { length :0 , code : 'vt'}
    },
    voting : {
        length : 0,
        code : 'vt'
    }
}

const _quizIdComponent : quizIdComponent = {
    length : 6,
    code : 'qz',
    bank : {
        length : 4,
        code : 'bn',
        question : {
            length : 4,
            code : 'qu',
            answer : {
                length : 2,
                code : 'an'
            }
        },
        tree : {
            length : 4,
            code : 'tr'
        }
    },
    metric : {
        length : -1,
        code : 'm_'
    }
}

const _creativeIdComponent : idComponent = {
    length : 6,
    code : 'cr'
}

const _chatIdComponent : chatIdComponent = {
    length : -1,
    code : 'ch',
    message : {
        length : 8,
        code : 'ms',
        voting : {
            length : 0,
            code : 'vt'
        }
    }
}

const PartyIdComponent : partyIdComponent = {
    length : 8,
    code : '_',
   chat : _chatIdComponent,
   main : {
    length : 0,
    code : 'mn',
    post : _postIdComponent,
    quiz : _quizIdComponent,
    creative : _creativeIdComponent
   },
   optional : {
    length : 0,
    code : 'op',
    post : _postIdComponent,
    quiz : _quizIdComponent,
    creative : _creativeIdComponent
   },
   popularity : {
    length : 4,
    code : 'pop'
   },
   votable : {
    length : 8,
    code : 'vb'
   }
}

export type PartyHexId = {
    id : string,
    [key : string] : string,
}

export type IdType = 'party' | 'chat' | 'message' | 'message-vote' | 'post' | 'post-vote' | 'post-element' | 'post-element-vote' | 'quiz' | 'quiz-bank' | 'quiz-question' | 'quiz-answer' | 'quiz-tree' | 'quiz-metric' | 'creative' | 'populatity' | 'votable';
export type IdTrack = 'n/a' | 'main' | 'optional';

export type ChunkComponentId = { 
        post? : { id : number, element? : {id : number, voting? : {id : number}}, voting? : {id : number}},
        quiz? : {id : number, 
                 metric? : { id : string}, 
                 bank?:  {id : number, question? : {id : number, answer? : {id : number}}, tree? : {id : number}}},
        creative? : {id : number}} 

export type PartyComponentId = {
    id : number;
    chat? : { id : string , message? : {id : number, voting? : {id : number}}},
    main? : ChunkComponentId;
    optional? : ChunkComponentId;
    popularity? : {id : number};
    votable? : { id : string};
    idType? : IdType;
    idTrack? : IdTrack;
}

const createChunkIdCopy = (chunk : ChunkComponentId) : ChunkComponentId => {
    const ret : ChunkComponentId = {
        post : chunk.post === undefined ? undefined : {id : chunk.post.id, element : chunk.post.element === undefined ? undefined : {id : chunk.post.element.id, voting : chunk.post.element.voting === undefined ? undefined : {id : chunk.post.element.voting.id}}, voting : chunk.post.voting === undefined ? undefined : { id : 0}},
        quiz : chunk.quiz === undefined ? undefined : {id : chunk.quiz.id, metric : chunk.quiz.metric === undefined ? undefined : {id : chunk.quiz.metric.id}, 
    bank : chunk.quiz.bank === undefined ? undefined : { id : chunk.quiz.bank.id , tree : chunk.quiz.bank.tree === undefined ? undefined : {id : chunk.quiz.bank.tree.id},  question : chunk.quiz.bank.question === undefined ? undefined : { id : chunk.quiz.bank.question.id, answer : chunk.quiz.bank.question.answer === undefined ? undefined : { id : chunk.quiz.bank.question.answer.id}}}},
    creative : chunk.creative === undefined ? undefined : {id : chunk.creative.id}
    }
    return ret;
}

export const createPartyIdCopy = (id : PartyComponentId) : PartyComponentId => {
    const ret : PartyComponentId = {
        id : id.id,
        chat : id.chat === undefined ? undefined : { id : id.chat.id, message : id.chat.message === undefined ? undefined : { id : id.chat.message.id, voting : id.chat.message.voting === undefined ? undefined : {id : id.chat.message.voting.id}}},
        main : id.main === undefined ? undefined : createChunkIdCopy(id.main),
        optional : id.optional === undefined ? undefined : createChunkIdCopy(id.optional),
        popularity : id.popularity === undefined ? undefined : {id : id.popularity.id},
        votable : id.votable === undefined ? undefined : {id : id.votable.id}
    };
    return ret;
}

const getComponentsForChunkFromHex = (hex : string, _index : number, ret : ChunkComponentId, chunker : chunkIdComponent) => {
    var index = _index;
    if(hex.length > (index + 2))
    {
        const cc1 = hex.slice(index, index + 2);
        if(cc1 === chunker.post.code)
        {
            ret.post = { id : parseInt(hex.slice(index+2, index + 2 + chunker.post.length),16)};
            index =  index + 2 + chunker.post.length;
            if(hex.length >= (index + 2))
            {
                const cc2 = hex.slice(index, index + 2);
                if(cc2 === chunker.post.element.code)
                {
                    ret.post.element = {id : parseInt(hex.slice(index + 2, index + 2 + chunker.post.element.length ),16)};
                    index = index + 2 + chunker.post.element.length;
                    if(hex.length > (index + 1))
                    {
                        ret.post.element.voting = {id : 0};
                    }
                }
                else if(cc2 === chunker.post.voting.code)
                {
                    ret.post.voting = {id : 0};
                }
            }

        }
        else if(cc1 === chunker.quiz.code)
        {
            ret.quiz = {id : parseInt(hex.slice(index+2, index + 2 + chunker.quiz.length),16)};
            index = index + 2 + chunker.quiz.length;
            if(hex.length > (index + 2))
            {
                const cc2 = hex.slice(index, index + 2);
                if(cc2 === chunker.quiz.bank.code)
                {
                    ret.quiz.bank = { id : parseInt(hex.slice(index+2, index + 2 + chunker.quiz.bank.length),16)}
                    index = index + 2 + chunker.quiz.bank.length;
                    if(hex.length > (index + 2))
                    {
                        const cc3 = hex.slice(index, index + 2);
                        if(cc3 === chunker.quiz.bank.question.code)
                        {
                            ret.quiz.bank.question = { id : parseInt(hex.slice(index+2, index + 2 + chunker.quiz.bank.question.length),16)}
                    index = index + 2 + chunker.quiz.bank.question.length;
                    if(hex.length > (index + 2))
                    {
                        const cc4 = hex.slice(index, index + 2);
                        if(cc4 === chunker.quiz.bank.question.answer.code)
                        {
                            ret.quiz.bank.question.answer = { id : parseInt(hex.slice(index+2, index + 2 + chunker.quiz.bank.question.answer.length),16)};
                        }
                    }

                        }
                        else if(cc3 === chunker.quiz.bank.tree.code)
                        {
                            ret.quiz.bank.tree = { id : parseInt(hex.slice(index+2, index + 2 + chunker.quiz.bank.tree.length),16)};

                        }
                    }

                }
                else if(cc2 === chunker.quiz.metric.code)
                {
                    ret.quiz.metric = { id : hex.slice(index+2)};
                }
            }

        }
        else if(cc1 === chunker.creative.code)
        {
            ret.creative = { id : parseInt(hex.slice(index+2, index + 2 + chunker.creative.length),16)};
        }
    }

}

export const createPartyComponentId = (hex : string ): PartyComponentId => {
    const ret : PartyComponentId = {
        id : parseInt(hex.slice(2,PartyIdComponent.length + 2), 16)
    };

    var index = PartyIdComponent.length + 2;

    if(hex.length > (index + 2))
    {
        const c1 = hex.slice(index, index + 2);
        if(c1 === PartyIdComponent.chat.code)
        {
            const end = hex.indexOf('$$', index+2);
            const cid = end < 0 ? hex.slice(index + 2) : hex.slice(index + 2, end);
            ret.chat = { id : cid};
            index = end < 0 ? hex.length : end + 2;
            if(hex.length > (index + 2))
            {
                const c2 = hex.slice(index, index + 2);
                if(c2 === PartyIdComponent.chat.message.code)
                {
                    ret.chat.message = { id : parseInt(hex.slice(index + 2, index + 2 + PartyIdComponent.chat.message.length),16)};
                    index = index + 2 + PartyIdComponent.chat.message.length;
                    if(hex.length > (index + 1))
                    {
                        ret.chat.message.voting = { id : 0};
                    }
                }
            }

        }
        else if(c1 === PartyIdComponent.main.code)
        {
            ret.main = { };
            getComponentsForChunkFromHex(hex, index + 2, ret.main, PartyIdComponent.main);

        }
        else if(c1 === PartyIdComponent.optional.code)
        {
            ret.optional = { };
            getComponentsForChunkFromHex(hex, index + 2, ret.optional, PartyIdComponent.optional);

        }
        else if(c1 === PartyIdComponent.popularity.code)
        {
            ret.popularity = { id : parseInt(hex.slice(index+ 2, index + 2 + PartyIdComponent.popularity.length),16)};
        }
        else if(c1 === PartyIdComponent.votable.code)
        {
            ret.votable = {id : hex.slice(index + 2)};
        }
    }
    return ret;
}

const convertChunkIdToHex = (id : ChunkComponentId, output : PartyHexId, chunker : chunkIdComponent) => {
    if(id.post !== undefined)
    {
        output.post = chunker.post.code + convertNumberToHex(id.post.id, chunker.post.length);
        output.id = output.id + output.post;
        if(id.post.element !== undefined)
        {
            output.element = chunker.post.element.code + convertNumberToHex(id.post.element.id, chunker.post.element.length);
            output.id = output.id + output.element;
            if(id.post.element.voting !== undefined)
            {
                output.voting = chunker.post.element.voting.code;
                output.id = output.id + output.voting;
            }
        }
        else if(id.post.voting !== undefined)
        {
            output.voting = chunker.post.voting.code;
            output.id = output.id + output.voting;
        }

    }
    else if(id.quiz !== undefined)
    {
        output.quiz = chunker.quiz.code + convertNumberToHex(id.quiz.id, chunker.quiz.length);
        output.id = output.id + output.quiz;
        if(id.quiz.metric !== undefined)
        {
            output.metric = chunker.quiz.metric.code + id.quiz.metric.id;
            output.id = output.id + output.metric;
        }
        else if(id.quiz.bank !== undefined)
        {
            output.bank = chunker.quiz.bank.code + convertNumberToHex(id.quiz.bank.id, chunker.quiz.bank.length);
            output.id = output.id + output.bank;
            if(id.quiz.bank.question !== undefined)
            {
                output.question = chunker.quiz.bank.question.code + convertNumberToHex(id.quiz.bank.question.id, chunker.quiz.bank.question.length);
                output.id = output.id + output.question;
                if(id.quiz.bank.question.answer !== undefined)
                {
                    output.answer = chunker.quiz.bank.question.answer.code + convertNumberToHex(id.quiz.bank.question.answer.id, chunker.quiz.bank.question.answer.length);
                    output.id = output.id + output.answer;
                }
            }
            else if(id.quiz.bank.tree !== undefined)
            {
                output.tree = chunker.quiz.bank.tree.code + convertNumberToHex(id.quiz.bank.tree.id, chunker.quiz.bank.tree.length);
                output.id = output.id + output.tree;
            }
        }

    }
    else if(id.creative !== undefined)
    {
        output.creative = chunker.creative.code + convertNumberToHex(id.creative.id, chunker.creative.length);
        output.id = output.id + output.creative;
    }
}

export const convertPartyIdToHex = (id : PartyComponentId) : PartyHexId => {
    const ret : PartyHexId = {
        id : PartyIdComponent.code + convertNumberToHex(id.id, PartyIdComponent.length)
    }

    ret.party = ret.id;
    if(id.chat !== undefined)
    {
        ret.chat = PartyIdComponent.chat.code + id.chat.id;
        ret.id = ret.id + ret.chat;
        if(id.chat.message !== undefined)
        {
            ret.message = PartyIdComponent.chat.message.code + convertNumberToHex(id.chat.message.id, PartyIdComponent.chat.message.length);
            ret.id = ret.id + '$$' + ret.message;
            if(id.chat.message.voting !== undefined)
            {
                ret.voting = PartyIdComponent.chat.message.voting.code;
                ret.id = ret.id + ret.voting;
            }
        }
    }
    else if(id.main !== undefined)
    {
        ret.main = PartyIdComponent.main.code;
        ret.id= ret.id + ret.main;
        convertChunkIdToHex(id.main, ret, PartyIdComponent.main);
    }
    else if(id.optional !== undefined)
    {
        ret.optional = PartyIdComponent.optional.code;
        ret.id = ret.id + ret.optional;
        convertChunkIdToHex(id.optional, ret, PartyIdComponent.optional);
    }
    else if(id.popularity!== undefined)
    {
        ret.popularity = PartyIdComponent.popularity.code + convertNumberToHex(id.popularity.id, PartyIdComponent.popularity.length);
    }
    else if(id.votable !== undefined)
    {
        ret.votable = PartyIdComponent.votable.code + id.votable.id;
    }
    return ret;

}

const TypeChunkId = (id : ChunkComponentId) : IdType => {
    if(id.post !== undefined)
        {
            
            if(id.post.element !== undefined)
            {
               
                if(id.post.element.voting !== undefined)
                {
                    return 'post-element-vote';
                }
                else
                return 'post-element';
            }
            else if(id.post.voting !== undefined)
            {
                return 'post-vote';
            }
            else
            return 'post'
    
        }
        else if(id.quiz !== undefined)
        {
            
            if(id.quiz.metric !== undefined)
            {
               return 'quiz-metric';
            }
            else if(id.quiz.bank !== undefined)
            {
                
                if(id.quiz.bank.question !== undefined)
                {
                    
                    if(id.quiz.bank.question.answer !== undefined)
                    {
                        return 'quiz-answer';
                    }
                    else
                    return 'quiz-question';
                }
                else if(id.quiz.bank.tree !== undefined)
                {
                    return 'quiz-tree';
                }
                else
                return 'quiz-bank';
            }
            else
            return 'quiz';
    
        }
        else if(id.creative !== undefined)
        {
            return 'creative';
        }
        else 
        return 'party';
}

export const TypeAndTrackPartyId = (id : PartyComponentId) =>
{
   
    if(id.chat !== undefined)
    {
        if(id.chat.message !== undefined)
        {
            if(id.chat.message.voting !== undefined)
            {
                id.idTrack = 'n/a';
                id.idType = 'message-vote';
            }
            else
            {
                id.idTrack = 'n/a';
                id.idType = 'message';
            }
        }
        else 
        {
            id.idTrack = 'n/a';
            id.idType = 'chat';
        }
    }
    else if(id.main !== undefined)
    {
        id.idTrack = 'main';
        id.idType = TypeChunkId(id.main);
    }
    else if(id.optional !== undefined)
    {
        id.idTrack = 'optional';
        id.idType = TypeChunkId(id.optional);
    }
    else if(id.popularity!== undefined)
    {
        id.idTrack = 'n/a';
        id.idType = 'populatity';
    }
    else if (id.votable !== undefined)
    {
        id.idTrack = 'n/a';
        id.idType = 'votable';
    }
    else
    {
        id.idTrack = 'n/a';
        id.idType = 'party';
    }
}









export const convertNumberToHex = (n: number, pad: number): string => {
    var s = n.toString(16);
    if (s.length < pad) {
        for (let i = s.length; i < pad; i++)
            s = "0" + s;
    }
    return s;
}

/*export type PartyId =
    {
        id: string;
        isComment: boolean;
        isPost: boolean;
        isPostElement: boolean;
        isSegment: boolean;
        isParty: boolean;
        party: number;
        partyHex: string;
        segment: number;
        segmentHex: string;
        post: number;
        postHex: string;
        postElement: number;
        postElementHex: string;
        comment: number;
        commentHex: string;
    }

export const CreatePartyIdFromHex = (hex: string): PartyId => {
    const partyHex = hex.slice(0, 8);
    const segmentHex = hex.slice(8, 8);
    const postHex = hex.slice(16, 4);
    const postElementHex = hex.slice(20, 2);
    const commentHex = hex.slice(22, 8);

    const party = parseInt(partyHex, 16);
    const segment = parseInt(segmentHex, 16);
    const post = parseInt(postHex, 16) - 1;
    const postElement = parseInt(postElementHex, 16) - 1;
    const comment = parseInt(commentHex, 16) - 1;

    return {
        id: hex,
        isComment: comment >= 0,
        isPostElement: postElement >= 0 && comment < 0,
        isPost: post >= 0 && comment < 0 && postElement < 0,
        isSegment: segment >= 0 && comment < 0 && postElement < 0 && post < 0,
        isParty: segment < 0 && post < 0 && postElement < 0 && comment < 0,
        party: party,
        partyHex: partyHex,
        segment: segment,
        segmentHex: segmentHex,
        post: post,
        postHex: postHex,
        postElement: postElement,
        postElementHex: postElementHex,
        comment: comment,
        commentHex: commentHex
    }
}

export const CreatePartyIdFromNumbers = (party: number, segment?: number, post?: number, postElement?: number, comment?: number): PartyId => {
    const partyHex = convertNumberToHex(party, 8);
    const segmentHex = segment === undefined ? '00000000' : convertNumberToHex(segment + 1, 8);
    const postHex = post === undefined ? '0000' : convertNumberToHex(post + 1, 4);
    const postElementHex = postElement === undefined ? '00' : convertNumberToHex(postElement, 2);
    const commentHex = comment === undefined ? '00000000' : convertNumberToHex(comment, 8);

    const isComment = comment === undefined ? false : comment >= 0;
    const isPostElement = (postElement === undefined ? false : postElement >= 0) && (!isComment);
    const isPost = (post === undefined ? false : post >= 0) && !(isComment || isPostElement);
    const isSegment = (segment === undefined ? false : segment > 0) && !(isComment || isPostElement || isPost);
    const isParty = !(isComment || isPostElement || isPost || isSegment);

    return {
        id: partyHex + postHex + postElementHex + commentHex,
        isComment: isComment,
        isPostElement: isPostElement,
        isPost: isPost,
        isSegment: isSegment,
        isParty: isParty,
        party: party,
        partyHex: partyHex,
        segment: segment === undefined ? -1 : segment,
        segmentHex: segmentHex,
        post: post === undefined ? -1 : post,
        postHex: postHex,
        postElement: postElement === undefined ? -1 : postElement,
        postElementHex: postElementHex,
        comment: comment === undefined ? -1 : comment,
        commentHex: commentHex
    }



}*/




